export default __webpack_public_path__ + "img/46d4edcd2ed41b4e3a27eff078bad596.png";